<template>
  <div>

    <Row :gutter="10">
      <DatePicker v-model="filterDate" type="daterange" :options="dateOptions" placeholder="Select date" :clearable="false"
                  format="dd/MM/yyyy" class="filterInput" style="width: 260px;" @on-change="onChangeDate"></DatePicker>

      <Col span="4">
        <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: cityFilter}"
                     :debounce="500" :skip="skipCity">
          <template slot-scope="{ result: { loading, error, data } }">
            <div v-if="loading"> Loading...</div>
            <div v-else-if="error"> Error Occured. {{error}}</div>
            <div v-else>
              <AutoComplete placeholder="Order City" v-model="city" :clearable="true" element-id="city"
                            @on-clear="onClearCity()" @on-search="onSearchCity($event)">
                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                  <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city)">{{cityObj.city}}</div>
                </Option>
              </AutoComplete>
            </div>
          </template>
        </ApolloQuery>
      </Col>

    </Row>
    <Row :gutter="10" style="margin: 10px 0 -10px 0">
      <Col span="3" class="sum-content">Σ On-Contract: {{onContractCount}}</Col>
      <Col span="3" class="sum-content">Σ Rented: {{rentedCount}}</Col>
      <Col span="4" class="sum-content">Σ LoadCapacity: {{totalLoadCapacity}}</Col>
      <Col span="4" class="sum-content">Σ OrdersAssigned: {{totalOrdersAssigned}}</Col>
      <Button v-if="isAdmin" @click="exportTempoOrders" style="float: right;">Export CSV</Button>
    </Row>
    <Spin fix size="small" v-if="skipTempoOrders"></Spin>
    <hot-table :settings="hotSettings" v-show="!skipTempoOrders" ref="hotTableComponent" style="margin: 20px 0 0 0">
      <hot-column v-for="(colset, index) in columns" :settings="colset" :key="index">
      </hot-column>
    </hot-table>

  </div>
</template>

<script>
  import {dateOptions} from "../ExcelFormattedOrders/Settings"
  import {SEARCH_CITY2} from "../../graphql/queries/territories"
  import {SUBSCRIBE_CANCEL_TEMPO_ORDERS} from "../../graphql/subscription/tempoOrders"
  import {calculateTotalWeightOfOrders, CellSettings} from "../ExcelTruckOrders/Settings"
  import { HotTable, HotColumn } from '@handsontable/vue'
  import moment from 'moment'
  import Handsontable from 'handsontable'
  import {contractType} from "../ExcelContractors/RendererFunctions";
  import {Constants} from "../../Constants/Constant";

  export default {
    name: "CancelTempoOrders",
    components: {HotTable, HotColumn},
    apollo: {
      $subscribe: {
        tempoOrders: {
          query: SUBSCRIBE_CANCEL_TEMPO_ORDERS,
          skip(){return this.skipTempoOrders},
          variables () {
            return {
              startDate: this.startDate,
              endDate: this.endDate,
              city: this.selectedCity
            }
          },
          result ({ data }) {
            this.tempoOrders = data.tempoOrders
            this.prepareSheetData(data.tempoOrders)
          },
        },
      },
    },
    data: function () {
      return {
        query_SEARCH_CITY: SEARCH_CITY2,
        tempoOrders: [],
        skipTempoOrders: true,
        city: '',
        skipCity: true,    //To Avoid calls at initial
        cityFilter: '%%',
        selectedCity: null,
        filterDate: [moment().subtract(2, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
        startDate: moment().subtract(2, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        dateOptions: dateOptions,
        columns: [
          //table_key_intermediate
          {
            title: 'Order<br> date',
            data: 'date',
            type: 'date',
            dateFormat: 'DD/MM/YYYY'
          },
          {
            title:'City',
            data: 'city'
          },
          {
            title: 'Contract<br> Type',
            data: 'contractType'
          },
          {
            title:'Status',
            data: 'status'
          },
          {
            title:'Order No',
            data: 'orderNum',
            renderer: this.tempoOrderNumRenderer
          },
          {
            title:'Tempo<br> Contractor',
            data: 'contractor',
            renderer: this.contractorRenderer
          },
          {
            title:'Tempo<br> Driver',
            data: 'driver',
            renderer: this.driverRenderer
          },
          {
            title:'Tempo<br> Number',
            data: 'tempoPlateNum',
            renderer: this.tempoPlateNumRenderer
          },
          {
            title:'Load<br> Capacity',
            data: 'capacity',
            type: 'numeric'
          },
          {
            title:'Order<br> Assigned',
            data: 'ordersAssigned',
            type: 'numeric'
          },
          {
            title:'Weight<br> Delivered',
            data: 'weightDelivered',
            type: 'numeric'
          },
          {
            title:'Start<br> KM',
            data: 'startKm',
            type: 'numeric'
          },
          {
            title:'End<br> KM',
            data: 'endKm',
            type: 'numeric'
          },
          {
            title:'KM Run',
            data: 'kmRun',
            type: 'numeric'
          },
          {
            title:'Price',
            data: 'price',
            type: 'numeric'
          }
        ],
        hotSettings: {
          data: null,
          readOnly: true,                             //default all cells readOnly
          fillHandle: false,
          copyPaste: false,
          licenseKey: "non-commercial-and-evaluation",
          autoRowSize: false,
          autoColumnSize: false,
          colWidths: [90, 100, 100, 145, 100, 110, 100, 125, 105, 105, 105, 80, 75, 95, 75],
          className: "htCenter htMiddle",
          filters: true,
          dropdownMenu: ['filter_by_condition', 'filter_operators', 'filter_by_condition2', 'filter_by_value', 'filter_action_bar'],
          columnSorting: { sortEmptyCells: true },
        },
        addTempoOrderDrawer: false,
        onContractCount: 0,
        rentedCount: 0,
        totalOrdersAssigned: 0,
        totalLoadCapacity: 0
      }
    },
    computed: {
      isAdmin: function(){
        return this.$store.state.userObj.role[0].id === Constants.adminRoleId
      }
    },
    methods: {
      tempoOrderNumRenderer(instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        let pRow = instance.toPhysicalRow(row)                               //When accessing original array
        let tempoOrder = this.tempoOrders[pRow]
        td.style.color = 'blue'
        td.classList.add('truck-order-num-txt')
        let self = this
        td.onclick = function() {
          self.$router.push({ path: '/excel-tempo-orders/'+tempoOrder.id})
        }
      },
      driverRenderer(instance, td, row, col, prop, value, cellProperties) {
        let pRow = instance.toPhysicalRow(row)                               //When accessing original array
        let tempoOrder = this.tempoOrders[pRow]
        td.innerHTML = value + '<br><span style="color: gray">' + tempoOrder?.driverDetail?.mobile + '</span>'
        td.style.verticalAlign = 'middle'
        td.style.textAlign = 'center'
      },
      contractorRenderer(instance, td, row, col, prop, value, cellProperties) {
        let pRow = instance.toPhysicalRow(row)                               //When accessing original array
        let tempoOrder = this.tempoOrders[pRow]
        td.innerHTML = value + '<br><span style="color: gray">' + tempoOrder?.contractorCode + '</span>'
        td.style.verticalAlign = 'middle'
        td.style.textAlign = 'center'
      },
      tempoPlateNumRenderer(instance, td, row, col, prop, value, cellProperties) {
        let pRow = instance.toPhysicalRow(row)                               //When accessing original array
        let tempoOrder = this.tempoOrders[pRow]
        td.innerHTML = value + '<br><span style="color: gray">' + tempoOrder?.tempo?.name + '</span>'
        td.style.verticalAlign = 'middle'
        td.style.textAlign = 'center'
      },
      onChangeDate(evt){
        this.startDate = moment(evt[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
        this.endDate = moment(evt[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
      },
      onSearchCity(event){
        this.cityFilter = '%' + this.city + '%';
        this.skipCity = false;
      },
      onSelectCity(city){
        this.selectedCity = city
      },
      onClearCity(){
        this.selectedCity = null
      },
      prepareSheetData(data){
        let mainArr = []
        data.forEach(curnt => {
          curnt.obj = {
            date: moment(curnt.date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            contractType: contractType[curnt.contractor.type],
            status: 'Cancel',
            orderNum: curnt.tempoOrderCode,
            contractor: curnt.contractor.name,
            driver: curnt.driverDetail.name,
            city: curnt.city,
            tempoPlateNum: curnt.tempo.platNo,
            capacity: curnt.tempo.capacity,
            numOfOrders: curnt.orderDetailsArr.length,
            truckOrders_ewayBillNo: curnt.ewayBillNo,
            ordersAssigned: curnt.orderDetailsArr.length,
            weightDelivered: calculateTotalWeightOfOrders(curnt.orderDetailsArr),
            startKm: curnt.startReading,
            endKm: curnt.endReading,
            kmRun: curnt.endReading?(curnt.endReading - curnt.startReading):'-',
            price: curnt.price?curnt.price:'-'
          }
          mainArr.push(curnt.obj)
        })
        this.hotSettings.data = mainArr
        this.updateTableSettings();
      },
      updateTableSettings(){
        this.totalLoadCapacity = 0;
        this.totalOrdersAssigned = 0;
        this.onContractCount = 0;
        this.rentedCount = 0;
        this.tempoOrders.forEach((curnt) => {
          if(curnt.contractor.type === 'RENTED') this.rentedCount++
          else if(curnt.contractor.type === 'ON_CONTRACT') this.onContractCount++

          this.totalLoadCapacity = this.totalLoadCapacity + curnt.tempo.capacity;
          this.totalOrdersAssigned = this.totalOrdersAssigned + curnt.orderDetailsArr.length;

        })
      },
      exportTempoOrders(){
        let hotInstance = this.$refs.hotTableComponent.hotInstance;
        let exportPlugin = hotInstance.getPlugin('exportFile');
        exportPlugin.downloadFile('csv', {
          columnHeaders: true,
          filename: 'Cancel_TempoOrders_' + moment().format('DD_MMM_YYYY_HH_mm'),
        });
      }
    },
    mounted(){
      setTimeout(() => {
        this.skipTempoOrders = false
      }, 500)

    }
  }
</script>

<style scoped>
  /deep/  .ivu-spin-fix {
    top: 43px;
    left: 16px;
    z-index: 8;
    width: 86vw;
    height: 40vh;
  }
  /deep/ .handsontable > .ht_master{
    font-size: 14px;
  }
  /deep/ .handsontable > .ht_master > .wtHolder{
    /*width: 100% !important;*/
    width: unset !important;
    height: unset !important;
  }
  /deep/ .handsontable span.colHeader {
    font-size: 13px;
  }
  /deep/.handsontable td{
    vertical-align: middle !important;
    padding: 0 1px 0 1px !important;
    white-space: unset !important;
    font-size: 13px;
  }

  /deep/.handsontable th{
    background-color: #d9d9d9;
    color: #222;
    text-align: center;
    font-weight: 600;
    vertical-align: middle !important;
    white-space: nowrap !important;
    padding: 0 0px 0 0px !important;
  }
  .filterInput{
    width: 80%;
  }
  /deep/ .ivu-date-picker-cells  {
    font-size: 12px !important;
  }
  /deep/ .ivu-picker-panel-sidebar  {
    width:125px !important;
    margin-left:-116px !important;
  }
</style>
<style>
  .truck-order-num-txt:hover {
    text-decoration: underline;
  }
  .filterInput{
    width: 80%;
  }
  .sum-content{
    font-size: 14px;
    padding: 10px 0 0 0;
  }
</style>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
